/**
 * @Author: Caroline
 * @Desc: 获取数据
 * @Date: 2021-3-17
 */

const getters = {
  // 用工中心 - 任务列表
  getTaskList(store) {
    return store.taskList;
  },

  //商户管理 -- 商户列表
  getCoopList(store) {
    return store.coopList;
  },

  //数据中心 -- 自由职业者结算统计
  getProfessionalList(store) {
    return store.professionalList;
  },

  //数据中心 -- 代理商交易统计
  getAgentList(store) {
    return store.agentList;
  },

  //数据中心 -- 代理商交易历史统计
  getAgentHistoryList(store) {
    return store.agentHistoryList;
  },

  //数据中心 -- 代理商交易统计详情
  getAgentDetailList(store) {
    return store.agentDetailList;
  },

  //数据中心 -- 商户结算列表
  getMerchantSettleList(store) {
    return store.merchantSettleList;
  },

  //数据中心 -- 批次交易明细
  getBatchTransDetailList(store) {
    return store.batchTransDetailList;
  },

  //财务中心 -- 余额管理 - 账单列表
  getBalanceAccList(store) {
    return store.balanceAccList;
  },

  //财务中心 -- 充值记录
  getRechargeRecordList(store) {
    return store.rechargeRecordList;
  },

  //财务中心 -- 电子回单
  getElectronicInfoList(store) {
    return store.electronicInfoList;
  },

  //财务中心 -- 完税证明
  getTaxProveList(store) {
    return store.taxProveList;
  },

  //财务中心 -- 完税证明详情
  getTaxProveDetailList(store) {
    return store.taxProveDetailList;
  },

  //财务中心 -- 子账户余额
  getSubsidiaryBalanceList(store) {
    return store.subsidiaryBalanceList;
  },

  //财务中心 -- 发票申请
  getInvoiceApplyList(store) {
    return store.invoiceApplyList;
  },

  //任务中心 -- 任务中心列表
  getTaskCenList(store) {
    return store.taskCenList;
  },

  // 任务中心 -- 任务中心列表 -- 任务中心详情
  getTaskCenDetailList(store) {
    return store.taskCenDetailList;
  },

  // 用工中心 - 任务列表 - 报名详情
  getTaskWokersList(store) {
    return store.taskWokersList;
  },

  // 用工中心 - 用工结算单
  getEmploymentStateList(store) {
    return store.employmentStateList;
  },

  // 用工中心 - 用工结算单 - 提交结算单
  getEmploymentStateSubmitList(store) {
    return store.employmentStateSubmitList;
  },

  // 用工中心 - 用工结算明细
  getEmploymentStateDescList(store) {
    return store.employmentStateDescList;
  },

  // 历史用工结算明细
  getHistoryEmploymentInfoList(store) {
    return store.historyEmploymentInfoList;
  },

  // 用工中心 - 自由职业者列表
  getProfessionList(store) {
    return store.professionList;
  },

  // 用工中心 - 结算单风控列表
  getRiskControlList(store) {
    return store.riskControlList;
  },

  // 资金下发管理 - 批次数据准备
  getSingleBatchDataList(store) {
    return store.singleBatchDataList;
  },

  // 资金下发管理 - 批次数据准备  - 提交
  getSingleBatchDataSubmitList(store) {
    return store.singleBatchDataSubmitList;
  },

  // 资金下发管理 - 多批次数据准备
  getMultiBatchDataList(store) {
    return store.multiBatchDataList;
  },

  // 资金下发管理 - 多批次数据准备 - 提交
  getMultiBatchDataSubmitList(store) {
    return store.multiBatchDataSubmitList;
  },

  // 资金下发管理 - 服务费明细列表
  getServiceChargeList(store) {
    return store.serviceChargeList;
  },

  // 自由职业者管理 - 自由职业者信息管理
  getWorkersInfoList(store) {
    return store.workersInfoList;
  },

  // 自由职业者管理 - 自由职业者签约状态
  getWorkersSignList(store) {
    return store.workersSignList;
  },

  // 管理中心 - 账户管理
  getAccountChildList(store) {
    return store.accountChildList;
  },

  // 资金下发管理 - 批次数据准备
  getSingleBatchDataList(store) {
    return store.singleBatchDataList;
  },

  // 资金下发管理 - 批次数据准备  - 提交
  getSingleBatchDataSubmitList(store) {
    return store.singleBatchDataSubmitList;
  },

  // 资金下发管理 - 多批次数据准备
  getMultiBatchDataList(store) {
    return store.multiBatchDataList;
  },

  // 资金下发管理 - 多批次数据准备 - 提交
  getMultiBatchDataSubmitList(store) {
    return store.multiBatchDataSubmitList;
  },

  // 自由职业者管理 - 自由职业者信息管理
  getWorkersInfoList(store) {
    return store.workersInfoList;
  },

  // 自由职业者管理 - 自由职业者签约状态
  getWorkersSignList(store) {
    return store.workersSignList;
  },

  // 管理中心 - 账户管理
  getAccountChildList(store) {
    return store.accountChildList;
  },

  // 自由职业者管理 -- 个体户信息管理
  getIndBusinessInfoManageList(store) {
    return store.indBusinessInfoManageList;
  },

  // 用工中心 - 任务列表 - 任务详情 - 回收站
  getRecycleBinList(store) {
    return store.recycleBinList;
  },

  // 自由职业者管理 -- 个体户订单管理
  getPerOrderList(store) {
    return store.perOrderList;
  },

  // 合规中心 - 任务信息维护
  getComplianceCenter(store) {
    return store.complianceCenter;
  },

  // 财务中心 - 开票记录
  getBillingRecordList(store) {
    return store.billingRecordList;
  },

  // 财务中心 - 开票信息管理 - 开票类目列表
  getInvoiceCategoryList(store) {
    return store.invoiceCategoryList;
  },

  // 数据中心 - 佣金结算订单
  getAgentBrokerageSettleRecord(store) {
    return store.agentBrokerageSettleRecord;
  },

  // 用工中心 - 用工花名册
  getEmploymentRoster(store) {
    return store.employmentRoster;
  },
  // 用工中心 - 测算工具分页
  getCalculationToolList(store) {
    return store.calculationToolList;
  }
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js